import { render, staticRenderFns } from "./ProviderOrderReceiverSelector.vue?vue&type=template&id=cfa90ae2&scoped=true&"
import script from "./ProviderOrderReceiverSelector.vue?vue&type=script&lang=js&"
export * from "./ProviderOrderReceiverSelector.vue?vue&type=script&lang=js&"
import style0 from "./ProviderOrderReceiverSelector.vue?vue&type=style&index=0&id=cfa90ae2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa90ae2",
  null
  
)

export default component.exports